/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Header_Duration_TitlecaseInputs */



/**
* | output |
* | --- |
* | "Duration" |
*
* @param {Ccsl_Export_Header_Duration_TitlecaseInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_header_duration_titlecase = /** @type {((inputs?: Ccsl_Export_Header_Duration_TitlecaseInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Header_Duration_TitlecaseInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Duree")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dauer")
	if (locale === "it") return /** @type {LocalizedString} */ ("Durata")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Продолжительность")
	if (locale === "es") return /** @type {LocalizedString} */ ("Duración")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("期间")
	if (locale === "ja") return /** @type {LocalizedString} */ ("間隔")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अवधि")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Duração")
	return /** @type {LocalizedString} */ ("Duration")
});